export default function reducer(state, action) {
  switch (action.type) {
    case "YARD_INFO":
      return {
        ...state,
        yardInfo: action.payload,
      };
    case "ADD_ACCESS":
      const access = state.yardInfo.accessToRailHighway
        ? state.yardInfo.accessToRailHighway
        : [];
      return {
        ...state,
        yardInfo: {
          ...state.yardInfo,
          accessToRailHighway: [...access, action.payload],
        },
      };
    case "REMOVE_ACCESS":
      const accessToRailHighway = state.yardInfo.accessToRailHighway.filter(
        (access) => access !== action.payload
      );
      return {
        ...state,
        yardInfo: { ...state.yardInfo, accessToRailHighway },
      };
    case "ERROR":
      return {
        ...state,
        errors: action.payload,
      };
    case "CLEAR_ERROR":
      return {
        ...state,
        errors: {},
      };
    case "CHANGE_SERVICE":
      debugger;
      return {
        ...state,
        services: [...action.payload],
      };
    case "ADD_COMMODITY":
      return {
        ...state,
        commodities: [
          ...state.commodities.map((itm) =>
            itm.id === action.payload.id ? { ...itm, active: true } : itm
          ),
        ],
      };
    case "REMOVE_COMMODITY":
      return {
        ...state,
        commodities: [
          ...state.commodities.map((itm) =>
            itm.id === action.payload.id ? { ...itm, active: false } : itm
          ),
        ],
      };
    case "ADD_CAPABILITY":
      return {
        ...state,
        capabilities: [
          ...state.capabilities.map((itm) =>
            itm.id === action.payload.id ? { ...itm, active: true } : itm
          ),
        ],
      };
    case "SET_FORKLIFT_MAX_CAPACITY":
      return {
        ...state,
        forkLiftMaxCapacity: action.payload,
      };
    case "REMOVE_CAPABILITY":
      return {
        ...state,
        capabilities: [
          ...state.capabilities.map((itm) =>
            itm.id === action.payload.id ? { ...itm, active: false } : itm
          ),
        ],
      };
    case "NOTE":
      return {
        ...state,
        note: action.payload,
      };
    case "SET_PRODUCT_PRICES":
      debugger;
      return {
        ...state,
        subscription: {
          ...state.subscription,
          priceList: action.payload,
        },
      };
    case "SET_SUBSCRIPTION":
      debugger;
      return {
        ...state,
        subscription: {
          ...action.payload,
        },
      };
    case "UPDATE_STATE":
      return {
        ...action.payload,
        validators: state.validators,
      };
    default:
      break;
  }
  return state;
}
